export default __webpack_public_path__ + "3e932b9c212d0049de184fc4f036479b.png";